import AlertModule from '@/store/vuex/aplicacao/AlertModule'

export const MENSAGEM_DE_INTEGRACAO_NAO_CONFIGURADA =
	'Configure o e-mail de envio da loja na aba Envio de e-mail para enviar e-mails ao cliente.'

export const MENSAGEM_DE_EMAIL_EM_ENVIO =
	'E-mail enviado ao cliente pelo e-mail da loja. Se ele falhar, você será avisado no sino.'

export function avisarErroDeEnvioDeEmail(error: unknown) {
	const resposta = (error as any)?.response
	if (resposta?.status === 422) {
		const texto = Array.isArray(resposta.data) && resposta.data[0]
			? resposta.data[0]
			: MENSAGEM_DE_INTEGRACAO_NAO_CONFIGURADA
		AlertModule.setWarning({ text: texto, timeout: 8000 })
		return
	}
	AlertModule.setError(error)
}
